import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const GoodsBaseUrl = '/business/goods'
export async function queryGoods(params) {
  const result = await request({
    url: GoodsBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query goods failed!') ?? null
}

export async function editGoods(id, goods) {
  const result = await request({
    url: GoodsBaseUrl + '/' + id,
    method: 'PUT',
    data: goods
  })
  return ResultHandler(result, 'Modify goods failed!')?.goods ?? []
}

export async function modifyGoodsFBA(id, goods) {
  const result = await request({
    url: GoodsBaseUrl + '/' + id + '/fba',
    method: 'PUT',
    data: goods
  })
  return ResultHandler(result, 'Modify goods failed!')?.goods ?? []
}

export async function removeGoods(id) {
  const result = await request({
    url: GoodsBaseUrl + '/' + id,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Modify goods failed!')?.goods ?? []
}

export function calcTotal(goods, attr) {
  let total = 0
  goods.forEach(element => {
    total = total + element[attr]
  })
  return total.toFixed(2)
}

export async function modifyGoodsNotes(id, notes) {
  const result = await request({
    url: GoodsBaseUrl + '/' + id + '/notes',
    method: 'PUT',
    data: { notes }
  })
  return ResultHandler(result, 'Modify notes failed!')?.goods ?? []
}
